import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import VisibleComponent from "./VisibleComponent";
import { OPERATE_COMPONENT_TYPE } from "../../../../common/enums/index"
import NativeComponent from "../NativeComponent";


const nativeComponentAbility = NativeComponent.nativeComponentAbility

export default class Webview extends VisibleComponent {
    constructor (...props) {
        const action = nativeComponentAPI.createWebview
        super(action, {}, ...props)
    }

    test1(){
        return new Promise(resolve => {
            resolve()
        })
    }

    @nativeComponentAbility
    test2(){
        return new Promise(resolve => {
            resolve()
        })
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    nativeLoadURL(params) {
        return operateComponentAPI.webviewLoadURL(params)
    }

    /**
     * 重新加载
     * @param params
     * @returns {*|Promise<any>}
     */
    reload(params) {
        return operateComponentAPI.webviewReload(params)
    }

    /**
     * 回退
     * @param params
     * @returns {*|Promise<any>}
     */
    goBack(params) {
        return operateComponentAPI.webviewGoBack(params)
    }

    /**
     * 重定向
     * @param params
     * @returns {*|Promise<any>}
     */
    goForward(params) {
        return operateComponentAPI.webviewGoForward(params)
    }

}
